"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var datapoints_1 = require("../datapoints");
var getUserConfiguration_1 = require("owa-session-store/lib/actions/getUserConfiguration");
var getWeatherForecastService_1 = require("../services/getWeatherForecastService");
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
var addWeatherDailyConditionsToStore = legacy_1.action('addWeatherDailyConditionsToStore')(function addWeatherDailyConditionsToStore(weatherDailyConditions, weatherForecastResponse) {
    if (weatherDailyConditions && weatherForecastResponse) {
        // Clear array, instead of constructing a new one.
        weatherDailyConditions.length = 0;
        var currentLocation = weatherForecastResponse.WeatherLocations[0];
        weatherDailyConditions.push(currentLocation.Conditions); // Weather right now.
        store_1.default.weatherClickThrough = currentLocation.ClickThrough;
        currentLocation.MultidayForecast.DailyForecasts.forEach(function (item) {
            weatherDailyConditions.push(item); // Weather for the following days.
        });
    }
});
exports.default = legacy_1.action('loadWeatherForecast', datapoints_1.default.loadWeatherForecast)(legacy_1.select({
    weatherDailyConditions: function () { return store_1.default.weatherDailyConditions; },
    weatherLocations: function () { return getUserConfiguration_1.default().UserOptions.WeatherLocations; },
    weatherUnit: function () { return getUserConfiguration_1.default().UserOptions.WeatherUnit; },
})(function loadWeatherForecast(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var locations_1, weatherForecastResponse;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(state.weatherLocations && state.weatherLocations.length > 0)) return [3 /*break*/, 2];
                    locations_1 = [];
                    state.weatherLocations.forEach(function (loc) {
                        locations_1.push({
                            EntityId: loc.LocationId,
                            Name: loc.Name,
                            Latitude: loc.Latitude ? parseFloat(loc.Latitude) : 0,
                            Longitude: loc.Longitude ? parseFloat(loc.Longitude) : 0,
                        });
                    });
                    return [4 /*yield*/, getWeatherForecastService_1.default(locations_1, state.weatherUnit)];
                case 1:
                    weatherForecastResponse = _a.sent();
                    addWeatherDailyConditionsToStore(state.weatherDailyConditions, weatherForecastResponse);
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=loadWeatherForecast.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-upnext/lib/actions/loadWeatherForecast.js
// module id = 4818
// module chunks = 48